module.exports = __webpack_public_path__ + "views/overview.27b58c1cce826b32d50f78ebea25c728.html";